import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fNumber(number) {
  return numeral(number).format();
}

export function fCurrency(number) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export function generateMixedId() {
  // 8 ký tự random (chữ hoa + chữ thường)
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let randStr = "";
  for (let i = 0; i < 8; i++) {
    randStr += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  // Ngày giờ hiện tại (YYYYMMDDHHMM)
  const now = new Date();
  const timestamp = now
    .toISOString()
    .replace(/[-T:]/g, "")
    .slice(0, 12); // Lấy YYYYMMDDHHMM

  // Ghép và trộn
  const combined = (randStr + timestamp).split("");
  for (let i = combined.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [combined[i], combined[j]] = [combined[j], combined[i]];
  }

  return combined.join("");
}